var elementsForm,contLogin;

$('.btnAddClient').click(function () {


    $('#formCreateClient').submit();
});

$("#formCreateClient").on('submit', function (e) {
    e.preventDefault();
    elementsForm = [
        "name_oc",
        "date",
        /*
        "name",
        "nit",
        "web",
        "web_status",
        "address",
        "city",
        "phone",
        "mail",
        "sector",
        "name_aut",
        "cc_aut",
        "position_aut",
        "mail_aut",
        "phone_aut",
        "numberList",
        */
    ];
    contLogin = validationForm(elementsForm,contLogin = 1);

    if(contLogin == 0)
    {
        swal({
            text: "Debes completar todos los datos",
            icon: imageURL,
            button: "OK!",
        });
        return false;
    }

    swal({
        text: "Espere un momento",
        icon: imageURL,
        button: false,
    });
    var data = $(this).serialize();
    $.ajax({
        url: https + "createClient",
        method: "POST",
        data: data,
        success: function (data) {
            console.log(data);
            
            if ($.trim(data) == "1") {
                uploadPhotoOne()
            }else if($.trim(data) == "2") {
                swal({
                    text: "No tiene los permisos necesarios",
                    icon: imageURL,
                    button: "OK!",
                });
            }else if($.trim(data) == "3"){
                swal({
                    text: `Ya existe el nit "${$('input[name="nit"]').val()}`,
                    icon: imageURL,
                    button: "OK!",
                });
            }else {
                swal({
                    text: "Error, hubo problemas",
                    icon: imageURL,
                    button: "OK!",
                });
            }
            
        }
    });
});


function uploadPhotoOne() {

    $avatarInput = $("#file");
    var formData = new FormData();
    formData.append('photo', $avatarInput[0].files[0]);
    formData.append('name_oc', $("#name_oc").val());
    $.ajax({
        url: https + "createClientUploadPhotoContract",
        method: "POST",
        data: formData,
        processData: false,
        contentType: false,
        success: function (datos) {
            if ($.trim(datos) == "1")
            {
                $("#formCreateClient")[0].reset();
                swal.close();
                swal({
                    text: "Cliente Creado con exito",
                    icon: imageURL,
                    button: false,
                });
                setInterval(function () {
                    location.href = https + 'dashboard';
                }, 200)
            }
            else
            {
                $("#formCreateClient")[0].reset();
                swal.close();
                swal({
                    text: "Cliente Creado con exito",
                    icon: imageURL,
                    button: false,
                });
                setInterval(function () {
                    location.href = https + 'dashboard';
                }, 200)
            }
        }
    });

}
function validationForm(elementsForm,contLogin)
{
    for(var i=0;i<elementsForm.length;i++){

        $('#'+elementsForm[i]).removeClass('error');

        if ( $.trim($("#"+elementsForm[i]).val()) == "" ) {
            contLogin = 0;
            $('#'+elementsForm[i]).addClass('error');
        }

    }

    return contLogin;
}
$('.uploadPhotoOne').click(function () {
    $('#file').click();
});

$('#file').change(function () {
    var fileList = this.files;
    var anyWindow = window.URL || window.webkitURL;
    //Como puedo subir multimples archivos, hago un for para recorrer todo lo subido
    $("#form_fotos").html('');
    for (var i = 0; i < fileList.length; i++) {
        var objectUrl = anyWindow.createObjectURL(fileList[i]);
        $("#form_fotos").append(fileList[i].name + '<br>');
    }
});

$('#formCreateClient .services .click-element').click(function () {
    $('#formCreateClient .services .click-element').removeClass('active');
    $(this).addClass('active');
    $('#formCreateClient .services .checks_list').removeClass('checks_list_active');
    $('#formCreateClient .services .checks_list_'+this.id).addClass('checks_list_active');
});

$('#formCreateClient .services .element-checks_list').click(function () {
    if($('#formCreateClient .services .element-checks_list #element-checks_list_'+this.id).prop('checked') ) {
        $('#formCreateClient .services .element-checks_list #element-checks_list_'+this.id).prop('checked',false);
        $('#formCreateClient .services .element-checks_list #element-checks_list_'+this.id).val('no');
        $('#formCreateClient .services .services_update .element-'+$(this).attr('idServ')+' h2 .span_'+this.id).css('display','none');
    }else{
        $('#formCreateClient .services .element-checks_list #element-checks_list_'+this.id).prop('checked',true);
        $('#formCreateClient .services .element-checks_list #element-checks_list_'+this.id).val('si');
        $('#formCreateClient .services .services_update .element-'+$(this).attr('idServ')+' h2').append('<span class="span_'+this.id+'">'+$(this).attr('name')+' - </span>');
    }
});


$('#formCreateClient .services .element-checks_list input').click(false);
$('#formCreateClient .fee .element-checks_list input').click(false);
$('#formCreateClient .annual .element-checks_list input').click(false);

$('#formCreateClient .fee .element-checks_list').click(function () {
    if($('#formCreateClient .fee .element-checks_list #'+this.id).prop('checked') ) {
        $('#formCreateClient .fee .element-checks_list #'+this.id).prop('checked',false);
        $('#formCreateClient .fee .element-checks_list #'+this.id).val('no');
    }else{
        $('#formCreateClient .fee .element-checks_list #'+this.id).prop('checked',true);
        $('#formCreateClient .fee .element-checks_list #'+this.id).val('si');
    }
});

$('#formCreateClient .annual .element-checks_list').click(function () {
    if($('#formCreateClient .annual .element-checks_list #'+this.id).prop('checked') ) {
        $('#formCreateClient .annual .element-checks_list #'+this.id).prop('checked',false);
        $('#formCreateClient .annual .element-checks_list #'+this.id).val('no');
    }else{
        $('#formCreateClient .annual .element-checks_list #'+this.id).prop('checked',true);
        $('#formCreateClient .annual .element-checks_list #'+this.id).val('si');
    }
});

$('#formCreateClient .annual .values').keypress(function () {
    validateAnnualValue();
});
$('#formCreateClient .annual .values').keydown(function () {
    validateAnnualValue();
});
$('#formCreateClient .annual .values').keyup(function () {
    validateAnnualValue();
});

function validateAnnualValue(){
    var total_value_annual = 0,
        hosting_value,domain_value = 0,
        technical_support_value,ssl_value = 0,
        content_admin_value = 0;
    setTimeout(function () {
        if ($('#formCreateClient .annual #hosting_value').val() != '') {
            hosting_value = convertNumber($('#formCreateClient .annual #hosting_value').val())
        }else{
            hosting_value=0
        }
        if ($('#formCreateClient .annual #domain_value').val() != '') { domain_value = convertNumber($('#formCreateClient .annual #domain_value').val()) }else{domain_value=0}
        //if ($('#formCreateClient .annual #technical_support_value').val() != '') { technical_support_value = convertNumber($('#formCreateClient .annual #technical_support_value').val()) }else{technical_support_value=0}
        //if ($('#formCreateClient .annual #ssl_value').val() != '') { ssl_value = convertNumber($('#formCreateClient .annual #ssl_value').val()) }else{ssl_value=0}
        if ($('#formCreateClient .annual #content_admin_value').val() != '') { content_admin_value = convertNumber($('#formCreateClient .annual #content_admin_value').val()) }else{content_admin_value=0}
        total_value_annual = parseInt(hosting_value)+parseInt(domain_value)+parseInt(content_admin_value);
        total_value_annual = new Intl.NumberFormat().format(total_value_annual);
        total_value_annual = total_value_annual.replace(/,/g , ".");
        $('#formCreateClient .annual #value_annual').val(total_value_annual);
    },10);
}

function convertNumber(cadena)
{
    cadena = cadena.replace("e", "");
    cadena = cadena.replace("E", "");
    cadena = cadena.replace("-", "");
    cadena = cadena.replace("+", "");
    cadena = cadena.replace(".", "");
    return cadena;
}

$('#formCreateClient .paymennts .values').keypress(function () {
    validatePaymentsValue();
});
$('#formCreateClient .paymennts .values').keydown(function () {
    validatePaymentsValue();
});
$('#formCreateClient .paymennts .values').keyup(function () {
    validatePaymentsValue();
});

function validatePaymentsValue(){
    var total_value_payments = 0,
        iva_value=0,
        value_pay_1=0,
        value_pay_2=0,
        value_pay_3=0,
        value_pay_4=0,
        value_pay_5=0,
        porcent_pay=0;
    setTimeout(function () {
        if ($('#formCreateClient .paymennts #value_iva').val() != '') { iva_value = convertNumber($('#formCreateClient .paymennts #value_iva').val()) }else{iva_value=0}
        if ($('#formCreateClient .paymennts #value_pay_1').val() != '') { value_pay_1 = convertNumber($('#formCreateClient .paymennts #value_pay_1').val()) }else{value_pay_1=0}
        if ($('#formCreateClient .paymennts #value_pay_2').val() != '') { value_pay_2 = convertNumber($('#formCreateClient .paymennts #value_pay_2').val()) }else{value_pay_2=0}
        if ($('#formCreateClient .paymennts #value_pay_3').val() != '') { value_pay_3 = convertNumber($('#formCreateClient .paymennts #value_pay_3').val()) }else{value_pay_3=0}
        if ($('#formCreateClient .paymennts #value_pay_4').val() != '') { value_pay_4 = convertNumber($('#formCreateClient .paymennts #value_pay_4').val()) }else{value_pay_4=0}
        if ($('#formCreateClient .paymennts #value_pay_5').val() != '') { value_pay_5 = convertNumber($('#formCreateClient .paymennts #value_pay_5').val()) }else{value_pay_5=0}
        total_value_payments = parseInt(iva_value)+parseInt(value_pay_1)+parseInt(value_pay_2)+parseInt(value_pay_3)+parseInt(value_pay_4)+parseInt(value_pay_5);
        var total_porcent_payments = total_value_payments;
        total_value_payments = new Intl.NumberFormat().format(total_value_payments);
        total_value_payments = total_value_payments.replace(/,/g , ".");
        $('#formCreateClient .paymennts .total').html('$'+total_value_payments);
        if(parseInt(value_pay_1) >= 0){
            porcent_pay = (100 * parseInt(value_pay_1)) / total_porcent_payments;
            $('#formCreateClient .paymennts #percent_pay_1').val(parseInt(porcent_pay)+'%');
        }
        if(parseInt(value_pay_2) >= 0){
            porcent_pay = (100 * parseInt(value_pay_2)) / total_porcent_payments;
            $('#formCreateClient .paymennts #percent_pay_2').val(parseInt(porcent_pay)+'%');
        }
        if(parseInt(value_pay_3) >= 0){
            porcent_pay = (100 * parseInt(value_pay_3)) / total_porcent_payments;
            $('#formCreateClient .paymennts #percent_pay_3').val(parseInt(porcent_pay)+'%');
        }
        if(parseInt(value_pay_4) >= 0){
            porcent_pay = (100 * parseInt(value_pay_4)) / total_porcent_payments;
            $('#formCreateClient .paymennts #percent_pay_4').val(parseInt(porcent_pay)+'%');
        }
        if(parseInt(value_pay_5) >= 0){
            porcent_pay = (100 * parseInt(value_pay_5)) / total_porcent_payments;
            $('#formCreateClient .paymennts #percent_pay_5').val(parseInt(porcent_pay)+'%');
        }
    },10);
}

var numberListEmails = 1,scriptArCreateClientEmail,arvCreateClientEmail;
scriptArCreateClientEmail = new Array();
scriptArCreateClientEmail[0] = "no";
scriptArCreateClientEmail[1] = "si";
arvCreateClientEmail = scriptArCreateClientEmail.toString();
$('#numberListEmails').val(arvCreateClientEmail);
$('#formCreateClient .add_email').click(function () {
    numberListEmails = numberListEmails + 1;
    scriptArCreateClientEmail[numberListEmails] = "si";
    arvCreateClientEmail = scriptArCreateClientEmail.toString();
    $('#numberListEmails').val(arvCreateClientEmail);
    $('.form_add_email').append('\n' +
        '                <div class="row form form_5">\n' +
        '                    <div class="col l4">\n' +
        '                    </div>\n' +
        '                    <div class="col l7">\n' +
        '                        <input type="text" class="input" id="email_annual_'+numberListEmails+'" name="email_annual_'+numberListEmails+'">\n' +
        '                    </div>\n' +
        '                </div>');
});

$('.si_domain_status').click(function () {
    $('#domain_status').val('si');
    $("#si_domain_status").prop('checked', true);
    $("#no_domain_status").prop('checked', false);
    $('#formCreateClient .annual .element-checks_list #domain').prop('checked',true);
    $('#formCreateClient .annual .element-checks_list #domain').val('si');
    $("#domain_comments").val($('#web').val());
    $("#domain_date").val($('#date').val());
    $("#domain_value").val('0');
    validateAnnualValue();
});
$('.no_domain_status').click(function () {
    $('#domain_status').val('no');
    $("#si_domain_status").prop('checked', false);
    $("#no_domain_status").prop('checked', true);
    $('#formCreateClient .annual .element-checks_list #domain').prop('checked',false);
    $('#formCreateClient .annual .element-checks_list #domain').val('no');
    $("#domain_comments").val('');
    $("#domain_date").val('');
    $("#domain_value").val('');
    validateAnnualValue();
});

$('.openClients').click(function () {
    location.href = https + 'client/open/'+this.id;
});